import { ChevronRight } from "lucide-react";
import { Link } from "react-router-dom";

/**
 * Gold-accented breadcrumb rendered inside the navy PageBanner.
 * Style is copied verbatim from the reference:
 *   <nav aria-label="Breadcrumb" class="mb-6">
 *     <ol class="flex items-center flex-wrap text-xs text-white/60">
 *       <li><a>Home</a></li>
 *       <li><ChevronRight class="h-3.5 w-3.5 mx-2 text-white/40" /><span class="text-mist-gold">Current</span></li>
 */
export default function Breadcrumb({ items }) {
  if (!items || items.length === 0) return null;
  return (
    <nav aria-label="Breadcrumb" className="mb-6" data-testid="breadcrumb">
      <ol className="flex items-center flex-wrap text-xs text-white/60">
        {items.map((it, i) => {
          const last = i === items.length - 1;
          return (
            <li key={i} className="flex items-center">
              {i > 0 && (
                <ChevronRight className="h-3.5 w-3.5 mx-2 text-white/40" aria-hidden />
              )}
              {last || !it.href ? (
                <span className={last ? "text-mist-gold" : ""}>{it.label}</span>
              ) : (
                <Link to={it.href} className="hover:text-mist-gold transition-colors">
                  {it.label}
                </Link>
              )}
            </li>
          );
        })}
      </ol>
    </nav>
  );
}
